import { useContext } from 'react';

import { ScrollableContext } from './scrollableContext';

export const useScrollable = () => {
  const context = useContext(ScrollableContext);

  if (!context) {
    throw new Error('useScrollable must be used within a ScrollableWrapper');
  }

  return context;
};
